import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EndPointUrl } from './api.enum';
import {AppService} from "../../../core/services/app.service";

@Injectable({
  providedIn: 'root'
})

export class _EvaluationService {
  constructor(private service: AppService) {
  }

  GetCollaborateurs(data, page): Observable<any> {
    const url: string = (<string>EndPointUrl.GET_COLLABORATEURS).replace('{page}', page);
    return this.service.postData(`${url}`, data);
  }

  GetSousCollaborateurs(data, page): Observable<any> {
    const url: string = (<string>EndPointUrl.GET_SOUSCOLLABORATEURS).replace('{page}', page);
    return this.service.postData(`${url}`, data);
  }

  GetAffectationEtendu(data, page): Observable<any> {
    const url: string = (<string>EndPointUrl.GET_AFFECTATION_ETENDU).replace('{page}', page);
    return this.service.postData(`${url}`, data);
  }


  }
